export enum CursorTypes {
  Default = 'default',
  Pointer = 'pointer',
  Text = 'text',
  Move = 'move',
  Grab = 'grab',
  Grabbing = 'grabbing',
  Crosshair = 'crosshair',
  ResizeNorth = 'n-resize',
  ResizeEast = 'e-resize',
  ResizeSouth = 's-resize',
  ResizeWest = 'w-resize',
  ResizeNorthEast = 'ne-resize',
  ResizeNorthWest = 'nw-resize',
  ResizeSouthEast = 'se-resize',
  ResizeSouthWest = 'sw-resize',
  ResizeEastWest = 'ew-resize',
  ResizeNorthSouth = 'ns-resize',
  ResizeNESW = 'nesw-resize',
  ResizeNWSE = 'nwse-resize',
}

// TODO: Thinking about refactoring this to use Tracked, then the prevCursor wouldn't need
//       to be set explicitly.
class Cursor {
  cursor: CursorTypes = CursorTypes.Default;

  prevCursor: CursorTypes = CursorTypes.Default; // Maybe this should be replaced by Tracked

  disabled = false;
}

export default Cursor;
